import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContentComponent } from './content.component';
import { TranslatorModule } from 'app/translator';

@NgModule({
  declarations: [
      ContentComponent
    ],
  imports: [
    CommonModule,
    RouterModule,
    TranslatorModule
  ],
  exports: [
      ContentComponent
    ]
})
export class ContentModule { }
